import { render, staticRenderFns } from "./lvItem.vue?vue&type=template&id=5368431d&scoped=true"
import script from "./lvItem.vue?vue&type=script&lang=js"
export * from "./lvItem.vue?vue&type=script&lang=js"
import style0 from "./lvItem.vue?vue&type=style&index=0&id=5368431d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368431d",
  null
  
)

export default component.exports